export default {
  default: [
    {
      path: "/klant/:id",
      name: "financeReceivers.view",
      component: () => import("./views/FinanceReceiverDetailsView.vue"),
      children: [
        {
          path: "onboarding",
          name: "financeReceivers.view.onboarding",
          component: () => import("@/modules/onboarding/views/OnboardingView.vue"),
        },
        {
          path: "wijziging-faciliteit",
          name: "financeReceivers.view.creditLimitRequest",
          component: () => import("@/modules/creditLimitRequest/views/CreditLimitRequestView.vue"),
        },
        {
          path: "algemeen",
          name: "financeReceivers.view.details",
          component: () => import("./views/FinanceReceiverDetails/DetailsView.vue"),
        },
        {
          path: "v1-redirect",
          redirect: { name: "financeReceivers.view" },
        },
        {
          path: "gebruikers/:accountId",
          name: "financeReceivers.view.account.details",
          component: () => import("@/modules/financeReceiverAccounts/views/FinanceReceiverAccountDetailsView.vue"),
        },
        {
          path: "faciliteit/leningen",
          name: "financeReceivers.view.facilities",
          component: () => import("@/modules/financeReceivers/views/FinanceReceiverDetails/FacilitiesView.vue"),
        },
        {
          path: "faciliteit/leningen/:loanId",
          name: "financeReceivers.view.facilities.loan",
          components: {
            default: () => import("@/modules/financeReceivers/views/FinanceReceiverDetails/FacilitiesView.vue"),
            sideBar: () => import("@/modules/loans/views/LoanDetailPanelView.vue"),
          },
        },
        {
          path: "faciliteit/vastgoedfinanciering",
          name: "financeReceivers.view.facilities.realEstate",
          component: () => import("@/modules/financeReceivers/views/FinanceReceiverDetails/RealEstateFacilityView.vue"),
        },
        {
          path: "risk-profile",
          name: "financeReceivers.view.riskProfile",
          component: () => import("./views/FinanceReceiverDetails/RiskProfileView.vue"),
        },
        {
          path: "agreements",
          name: "financeReceivers.view.agreements",
          component: () => import("./views/FinanceReceiverDetails/AgreementsView.vue"),
        },
        {
          path: "collaterals",
          redirect: { name: "financeReceivers.view.agreements" },
        },
        {
          path: "communication",
          name: "financeReceivers.view.communication",
          component: () => import("./views/FinanceReceiverDetails/CommunicationView.vue"),
        },
        {
          path: "notes",
          redirect: { name: "financeReceivers.view.communication" },
        },
        {
          path: "notes/:noteId",
          name: "financeReceivers.view.notes.detail",
          components: {
            default: () => import("./views/FinanceReceiverDetails/CommunicationView.vue"),
            sideBar: () => import("./views/FinanceReceiverInternalNotesView.vue"),
          },
        },
        {
          path: "cashflow",
          name: "financeReceivers.view.cashflow",
          component: () => import("@/modules/cashflow/views/CashflowView.vue"),
        },
        {
          path: "repayment-flow",
          name: "financeReceivers.view.repaymentFlow",
          component: () => import("@/modules/financeReceivers/views/FinanceReceiverDetails/InsightsView.vue"),
        },
      ],
    },
    {
      path: "/klant/:id/faciliteit/aanpassen",
      name: "financeReceivers.view.facilities.edit",
      component: () => import("@/modules/financeReceivers/views/FinanceReceiverFacilitiesFormView.vue"),
    },
    {
      path: "/klant/:id/faciliteit/aanpassen-met-nieuwe-offerte",
      name: "financeReceivers.view.facilities.new.quote.edit",
      component: () => import("@/modules/financeReceivers/views/FinanceReceiverFacilitiesNewQuoteFormView.vue"),
    },
    {
      path: "/klant/:id/faciliteit/aanmaken",
      name: "financeReceivers.view.facilities.create",
      component: () => import("@/modules/financeReceivers/views/FinanceReceiverFacilitiesFormView.vue"),
    },
    {
      path: "/klant/:id/vastgoedfinanciering/aanmaken",
      name: "financeReceivers.view.realEstateFacility.create",
      component: () => import("@/modules/financeReceivers/views/RealEstateFacilityFormView.vue"),
    },
    {
      path: "/klant/:id/vastgoedfinanciering/:loanId/wijzigen",
      name: "financeReceivers.view.realEstateFacility.edit",
      component: () => import("@/modules/financeReceivers/views/RealEstateFacilityFormView.vue"),
    },
    {
      path: "/klant/:id/wijzigen",
      name: "financeReceivers.edit",
      component: () => import("./views/FinanceReceiverFormView.vue"),
    },
    {
      path: "/klant/aanmaken",
      name: "financeReceivers.realEstate.create",
      component: () => import("./views/FinanceReceiverRealEstateFormView.vue"),
    },
    {
      path: "/klanten",
      name: "financeReceivers.tables",
      component: () => import("./views/FinanceReceiversView.vue"),
      redirect: { name: "financeReceivers.table.all" },
      children: [
        {
          path: "/klanten/alle-klanten",
          name: "financeReceivers.table.all",
          component: () => import("./views/Tables/AllFinanceReceiversTableView.vue"),
        },
        {
          path: "/klanten/in-gebreke",
          name: "financeReceivers.table.defaulting",
          component: () => import("./views/Tables/DefaultingFinanceReceiversTableView.vue"),
        },
        {
          path: "/klanten/in-bijzonder-beheer",
          name: "financeReceivers.table.delinquent",
          component: () => import("./views/Tables/DelinquentFinanceReceiversTableView.vue"),
        },
        {
          path: "/klanten/in-bijzonder-beheer/:id/notes",
          redirect: { name: "financeReceivers.table.delinquent" },
        },
        {
          path: "/klanten/in-bijzonder-beheer/:id/notes/:noteId",
          name: "financeReceivers.table.delinquent.note.view",
          components: {
            default: () => import("./views/Tables/DelinquentFinanceReceiversTableView.vue"),
            sideBar: () => import("./views/FinanceReceiverInternalNotesView.vue"),
          },
        },
      ],
    },
  ],
};
